import { jsPDF } from "jspdf";
import html2pdf from "html2pdf.js";

export function generatePDF(element: HTMLElement, fileName: string) {
    const options = {
        filename: fileName,
        html2canvas: {
            useCORS: true,
            logging: true,
            letterRendering: true, // Tenta melhorar a renderização das letras
            scale: 1, // Evitar redimensionamento
            backgroundColor: "#fff", // Evitar fundo transparente
            removeContainer: true, // Não desenhar o container como uma imagem
        },
        jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
            compress: true, // Melhor compressão do conteúdo
            textRenderingMode: 2, // Melhor renderização de texto (sempre tentará manter como texto)
        },
    };

    // Gerar o PDF
    html2pdf()
        .set(options)
        .from(element)
        .save();
}

export async function generatePDF2(
    element: HTMLElement,
    fileName: string,
    orientation: "portrait" | "landscape"
) {
    const server = process.env.VUE_APP_HOST ?? "";

    const pdf = new jsPDF({
        format: "a4",
        orientation: orientation ?? "portrait",
        unit: "mm",
    });

    const font = new FontFace(
        "OpenSans",
        `url('${server}/fonts/open-sans/OpenSans-Regular.ttf')`
    );

    await font.load();

    document.fonts.add(font);

    pdf.html(element, {
        filename: fileName,
        windowWidth: orientation === "portrait" ? 794 : 1118,
        width: orientation === "portrait" ? 210 : 297,
        callback: function (pdf) {
            pdf.save();
        },
        margin: [0, 0, 0, 0],
        x: 0,
        y: 0,
    })
}

function base64ToArrayBuffer(base64: string): Uint8Array {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export async function pdfToImages(pdfBase64: string): Promise<string[]> {
    const images: string[] = [];

    console.log({ file: pdfBase64 })

    return images;
}

export function getStyledHTML(element: HTMLElement) {
    const cloned = element.cloneNode(true) as HTMLElement;

    // Aplica estilos "computados" inline (necessário por causa do scoped)
    const applyComputedStyles = (sourceEl: HTMLElement, targetEl: HTMLElement) => {
        const computed = getComputedStyle(sourceEl);
        for (const prop of computed) {
            targetEl.style.setProperty(prop, computed.getPropertyValue(prop));
        }

        Array.from(sourceEl.children).forEach((child, i) => {
            applyComputedStyles(child as HTMLElement, targetEl.children[i] as HTMLElement);
        });
    };

    applyComputedStyles(element, cloned);

    // Empacota em HTML completo com meta e charset
    return `
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
            /* Reset geral */
            * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            }

            html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            font-family: ''OpenSans'', sans-serif;
            font-size: 12px;
            background: white !important;
            }

            hr {
            margin-block-start: 1rem;
            margin-block-end: 1rem;
            }

            h4 {
            margin-block-start: 0.25rem;
            margin-block-end: 0.5rem;
            }

            ul {
            margin-block-start: 0;
            margin-block-end: 0;
            }

            ul li {
            margin-block-start: 0.25rem;
            margin-block-end: 0.25rem;
            }

            p {
            margin-block-start: 0.25rem;
            margin-block-end: 0.5rem;
            }

            body {
            background: white !important;
            }

            .page-body {
            display: flex;
            flex-direction: column;
            margin: 1.5em; /* Ajuste das margens para melhor visualização */
            background: white;
            font-size: 12px; /* Font-size menor, pois o padrão é muito grande */
            }

            .page-title {
            display: flex;
            align-items: center;
            width: 100%;
            height: 2.25em;
            padding-inline-start: 1em;
            margin-block-end: 0.75em;
            background: var(--white-off, #f7f7f7); /* Ajuste de cor de fundo */
            color: black;
            font-size: 1em; /* Font maior para títulos */
            font-weight: bold;
            text-transform: uppercase;
            }

            .page-content {
            margin-block-end: 2em;
            padding-inline: 1em;
            }

            .company {
            display: flex;
            flex-direction: row;
            gap: 1em;
            }

            .brand {
            min-width: 5em;
            width: 5em;
            height: 5em;
            }

            .brand img {
            width: 100%;
            height: auto;
            }

            .infos {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 0.2rem;
            }

            .name {
            font-size: 0.875em;
            }

            .document {
            font-size: 0.75em;
            font-weight: bold;
            }

            .address {
            font-size: 0.75em;
            text-transform: uppercase;
            }

            .methods {
            display: flex;
            flex-direction: column;
            gap: 1em;
            font-size: 0.875em;
            }

            .page {
            display: flex;
            flex-direction: column;
            width: 794px; /* A largura A4 em pixels (aproximadamente 21cm) */
            height: 1123px; /* A altura A4 em pixels (aproximadamente 29.7cm) */
            font-size: 12px;
            page-break-after: always;
            border: 1px solid var(--border, #ccc);
            margin: 0 auto; /* Centraliza a página */
            }

            .page.print {
            border: none;
            }

            .content {
            flex: 1;
            }

            .footer {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.15em;
            width: 90%;
            margin-inline: auto;
            padding-block-start: 0.25em;
            border-block-start: 1px solid var(--border, #ccc);
            }

            .footer .title {
            font-size: 0.9em;
            text-transform: uppercase;
            }

            .footer .subtitle {
            font-size: 0.75em;
            }

            .page-number {
            display: flex;
            width: 90%;
            margin-inline: auto;
            height: 1.5em;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-end;
            font-size: 1em;
            font-weight: bold;
            margin-bottom: 2em;
            }

            /* Ajustes gerais para o PDF */
            @page {
            size: A4;
            margin: 10mm; /* Ajuste para evitar grandes margens */
            }
          </style>
        </head>
        <body>
          ${cloned.outerHTML}
        </body>
      </html>
    `;
}


export function downloadBase64Pdf(base64: string, filename: string) {
    // Converte para Blob
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Cria URL temporária
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Limpeza
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
}

